import React from 'react'
import PropTypes from 'prop-types'
import InputLabel from '@iui-kit/components/InputLabel'
import { parsePhoneNumberFromString } from 'libphonenumber-js/mobile'

const PhoneInput = ({
  name,
  label,
  size,
  value,
  isValid,
  required,
  handleBlur,
  setFieldValue,
  placeholder
}) => {
  const handleChange = ({ target }) => {
    const formattedPhoneNumber = parsePhoneNumberFromString(target.value, 'RU')
    let number
    try {
      number = formattedPhoneNumber.formatInternational()
    } catch (e) {
      number = target.value
    }
    setFieldValue(name, number)
  }

  return (
    <InputLabel
      size={size}
      value={value}
      required={required}
      name={name}
      label={label}
      isValid={isValid}
      onChange={handleChange}
      handleBlur={handleBlur}
      placeholder={placeholder}
    />
  )
}

PhoneInput.propTypes = {
  valid: PropTypes.bool,
  size: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.string.isRequired,
  required: PropTypes.bool,
  isValid: PropTypes.bool,
  handleBlur: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  placeholder: PropTypes.string
}

export default PhoneInput
